import React, { useEffect, useState, useCallback, useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
    Update,
    GetAllPoolName,
    InhouseGuest,
    GetById
} from "adminApi/PoolBookingApi/PoolBooking.js";
import { validateForm } from "utils/validation";
import { PoolBookingRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import fields from "../json/PoolBookingFields.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import EditPoolBookingForm from "./components/EditPoolBookingForm";
import useFetchAllData from "Hooks/useFetchAllData";
import useFetchFormDataById from "Hooks/useFetchFormDataById";

const EditPoolBooking = () => {
    const navigate = useNavigate();
    const [CustomerOpctions, setCustomerOpctions] = useState([]);

    const { id } = useParams();

    const extraData = [
        { "name": "from_date" },
        { "name": "to_date" }
    ];

    const { formdata } = fields;

    const allFields = useMemo(
        () => [...formdata, ...extraData],
        []
    );

    const initialValues = useMemo(() => {
        return allFields.reduce((acc, field) => {
            acc[field.name] = "";
            return acc;
        }, {});
    }, [allFields]);

    const {
        values,
        errors,
        handleChange,
        setErrors,
        setValues
    } = useFormChange(initialValues, PoolBookingRules);

    const { data: PooNameOptions = [] } = useFetchAllData(GetAllPoolName);

    // Fetch existing data by ID
    const { loading: loadingFetch } = useFetchFormDataById(
        id,
        formdata,
        GetById,
        setValues
    );

    /* ---------- INHOUSE GUEST ---------- */
    const getInhouseGuest = useCallback(async ({ from_date, to_date }) => {
        try {
            const res = await InhouseGuest({ data: { from_date, to_date } });
            const data = res?.data?.data?.data || [];
            setCustomerOpctions(data);
        } catch (err) {
            console.error(err);
        }
    }, []);

    /* ---------- PACKAGE CHANGE ---------- */
    useEffect(() => {
        if (!values.p_pack_id) return;

        const pkg = PooNameOptions.find(
            p => p.pool_package_id === Number(values.p_pack_id)
        );
        if (!pkg) return;

        setValues(prev => ({
            ...prev,
            price: pkg.price,
            from_date: pkg.from_date,
            to_date: pkg.to_date
        }));

        if (pkg.from_date && pkg.to_date) {
            getInhouseGuest(pkg);
        }
    }, [values.p_pack_id, PooNameOptions, setValues, getInhouseGuest]);

    /* ---------- FORM SUBMIT ---------- */
    const { loading, handleSubmit } = useFormSubmit(
        async (formValues) => {
            // Copy before mutating — never mutate the original formValues object
            const payload = { ...formValues };
            delete payload.to_date;
            delete payload.from_date;
            delete payload.customer_type;
            // amount = price (single unit price × units is computed server-side)
            payload.amount = Number(values.price);
            if (payload.new_customer) {
                delete payload.customer_id;
            }
            return await Update({ id, data: payload });
        },
        (vals) => {
            const err = validateForm(vals, PoolBookingRules);
            setErrors(err);
            return err;
        },
        () => navigate(-1),
        "Pool Booking Updated Successfully"
    );

    return (
        <>
            {(loading || loadingFetch) && <Spinner isSpinner />}
            <EditPoolBookingForm
                fields={formdata}
                values={values}
                errors={errors}
                handleChange={handleChange}
                handleSubmit={(e) => handleSubmit(e, values)}
                loading={loading}
                PooNameOptions={PooNameOptions}
                CustomerOpctions={CustomerOpctions}
            />
        </>
    );
};

export default EditPoolBooking;
